enum Color {
    Negative = '#de1414',
    Normal = '#f2b301',
    Positive = '#4caf50',

    NormalBlue = '#1e88e5',
    NormalOrange = '#f8883c',
    NormalGray = '#999',

    White = '#fff',

    Blue20 = '#D1E4FE',
    Blue40 = '#76ADFE',
    Blue50 = '#468FFD',
    Blue60 = '#0070FF',
    Blue70 = '#0058CC',
    Blue80 = '#00429B',

    Green10 = '#F0FBF3',
    Green20 = '#E0F6E5',
    Green30 = '#A5E2B6',
    Green40 = '#83D99C',
    Green50 = '#5BCF83',
    Green60 = '#0DC267',
    Green70 = '#0EA658',
    Green80 = '#0D8847',

    Yellow40 = '#F7D044',
    Yellow60 = '#D9B63A',
    Yellow70 = '#C8A836',

    Orange10 = '#FFEEDD',
    Orange20 = '#FFDDBB',
    Orange30 = '#FECB97',
    Orange40 = '#FDB972',
    Orange60 = '#FF9900',
    Orange70 = '#BF7104',
    Orange80 = '#8A5100',

    Red20 = '#FDB5A7',
    Red30 = '#FF9F8F',
    Red40 = '#FF8A77',
    Red60 = '#FF4D3A',
    Red70 = '#D64030',

    Gray10 = '#F4F6FB',
    Gray20 = '#EEF1F7',
    Gray30 = '#CCD5DF',
    Gray40 = '#AABBCA',
    Gray50 = '#768694',
    Gray60 = '#5E6C77',
    Gray70 = '#3F4850',
    Gray80 = '#2A3137',

    Violet10 = '#F3EEFF',
    Violet20 = '#DBCDFF',
    Violet30 = '#AF8BF5',
    Violet40 = '#9A67EF',
    Violet50 = '#9054EA',
    Violet60 = '#883BE9',
}

export default Color;
